/*@ngInject*/
export default ['IntlTelInput', function (IntlTelInput) { return function (countryCode) {
        var country = IntlTelInput.getCountryData().find(function (e) { return e.iso2 === countryCode.toLowerCase(); });
        return country && country.name;
    }; }];
//# sourceMappingURL=isoCodeCountryToCountry.js.map